import { CancelTokenSource } from 'axios'
import { IListModel, IPaginationModel } from 'shared/models/List'
import { IUnitIdentificationFields } from 'shared/models/Unit'

export enum IPortalUserRoleEnum {
  all = 'All',
  owner = 'Owner',
  tenant = 'Tenant',
  cohabitant = 'CoResident',
  proxyOwner = 'ProxyOwner',
  notSignedIn = 'NotSignedIn',
}

export enum IPortalUserSortColumnEnum {
  name = 'Name',
  reservedAgainstElectronicCommunication = 'ReservedAgainstElectronicCommunication',
  address = 'Address',
  propertySectionNo = 'PropertySectionNo',
}

export interface IPortalUserFilter extends IPaginationModel {
  clientId: string
  sortorder: string
  sortColumn: IPortalUserSortColumnEnum
  searchText: string
  portalUserRole?: IPortalUserRoleEnum
  source: CancelTokenSource
}

export type IPortalUserResponseModel = IListModel<IPortalUserModel>

export interface IPortalUserModel {
  nameregisterId: string
  isProxyOwner: boolean
  isOwner: boolean
  isTenant: boolean
  isCoResident: boolean
  address: string
  propertySectionNo: string
  emailNotificationCount?: number
  reservedAgainstElectronicCommunication?: Date
  isRegistered: boolean
  name: string
  // Might move this model out (used 3 places)
  unitIdentificationFields: IUnitIdentificationFields
}

export interface IPortalUserSummary {
  ownersCount: number
  tenantsCount: number
  coResidentsCount: number
  proxyOwnerCount: number
  notSignedInCount: number
  reservedAgainstElectronicCommunicationCount: number
}
